export type SentimentValue = 'positive' | 'negative' | 'neutral' | 'mostly_positive' | 'mostly_negative' | 'controversial';

// TODO: replace placeholder colors with design tokens once provided
// `fill` is a softened tint of `text` for area fills (map regions) so borders
// and labels stay readable; `text` doubles as the full-strength hover color.
export const SENTIMENT_COLORS: Record<SentimentValue, { text: string; fill: string }> = {
  positive:        { text: '#067647', fill: '#b5dfc9' },
  negative:        { text: '#EF4444', fill: '#fecaca' },
  neutral:         { text: '#FFA100', fill: '#fde3b3' },
  mostly_positive: { text: '#067647', fill: '#b5dfc9' },
  mostly_negative: { text: '#EF4444', fill: '#fecaca' },
  controversial:   { text: '#000000', fill: '#d1d5db' },
};

// Map-widget-specific sentiment colors from design: `fill` is the base area
// color (map regions, legend swatches); `hover` is the darker hover variant.
export const MAP_SENTIMENT_COLORS: Record<SentimentValue, { fill: string; hover: string }> = {
  positive:        { fill: '#22C55F', hover: '#1FB156' },
  negative:        { fill: '#EF4444', hover: '#D73D3D' },
  neutral:         { fill: '#FFCC33', hover: '#E5B82E' },
  mostly_positive: { fill: '#64D68F', hover: '#5AC181' },
  mostly_negative: { fill: '#F47C7C', hover: '#DC7070' },
  controversial:   { fill: '#A87BD9', hover: '#976FC3' },
};

/** Display order for sentiment legends: positive → negative, controversial last. */
export const SENTIMENT_ORDER: SentimentValue[] = [
  'positive',
  'mostly_positive',
  'neutral',
  'mostly_negative',
  'negative',
  'controversial',
];

/** Human-readable sentiment label: 'mostly_negative' → 'Mostly negative'. Unrecognized values pass through as-is. */
export function formatSentimentLabel(raw: unknown): string {
  const normalized = normalizeSentiment(raw);
  if (!normalized) return String(raw ?? '');
  const spaced = normalized.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function normalizeSentiment(raw: unknown): SentimentValue | null {
  if (raw === null || raw === undefined || raw === '') return null;
  const key = String(raw).toLowerCase().trim() as SentimentValue;
  return Object.prototype.hasOwnProperty.call(SENTIMENT_COLORS, key) ? key : null;
}
